export const FULL_ACCESS = "FULL_ACCESS";
const BLOCKED_BILLING_ROUTE = "/billing";
const BLOCKED_NOTICE_ROUTE = "/account-payment-required";
const BLOCKED_INACTIVE_ROUTE = "/account-inactive";

const toNumberOrNull = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const parsedValue = Number(value);

  return Number.isNaN(parsedValue) ? null : parsedValue;
};

const toDateOrNull = (value) => {
  if (!value) {
    return null;
  }

  const parsedDate = new Date(value);

  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export const getCustomerLicenseStatus = (user) => {
  if (user?.userType !== "Customer") {
    return {
      isBlocked: false,
      reason: null,
      redirectPath: null,
    };
  }

  const customer = user?.customer || {};

  if (customer?.status === "INACTIVE") {
    return {
      isBlocked: true,
      reason: "ACCOUNT_INACTIVE",
      redirectPath: BLOCKED_INACTIVE_ROUTE,
    };
  }

  const isOnTrial = customer?.status === "ON_TRIAL";
  const numUnits = toNumberOrNull(customer?.numUnits);
  const numLicensedUnits = toNumberOrNull(customer?.numLicensedUnits);
  const licenseExpiresAt = toDateOrNull(customer?.licenseExpiresAt);
  const isUnitLimitExceeded =
    !isOnTrial &&
    numUnits !== null &&
    numLicensedUnits !== null &&
    numUnits > numLicensedUnits;
  const isLicenseExpired =
    licenseExpiresAt !== null &&
    Date.UTC(
        licenseExpiresAt.getUTCFullYear(),
        licenseExpiresAt.getUTCMonth(),
        licenseExpiresAt.getUTCDate(),
        23,
        59,
        59,
        999,
      ) < Date.now();

  if (!isUnitLimitExceeded && !isLicenseExpired) {
    return {
      isBlocked: false,
      reason: null,
      redirectPath: null,
    };
  }

  return {
    isBlocked: true,
    reason: isUnitLimitExceeded ? "UNIT_LIMIT_EXCEEDED" : "LICENSE_EXPIRED",
    redirectPath:
      user?.userAccessType === FULL_ACCESS
        ? BLOCKED_BILLING_ROUTE
        : BLOCKED_NOTICE_ROUTE,
  };
};

export const customerNeedsLicenseAgreement = (user) =>
  user?.userType === "Customer" &&
  user?.userAccessType !== "SUPPORT" &&
  user?.hasAcceptedLicenseAgreement === false;

export const isCustomerPaidUpToDate = (user) => {
  const { reason } = getCustomerLicenseStatus(user);

  return reason !== "UNIT_LIMIT_EXCEEDED" && reason !== "LICENSE_EXPIRED";
};

export const normalizeCurrentUser = (user) => {
  if (!user) {
    return user;
  }

  return {
    ...user,
    licenseStatus: getCustomerLicenseStatus(user),
  };
};

export const blockedCustomerRoutes = {
  billing: BLOCKED_BILLING_ROUTE,
  notice: BLOCKED_NOTICE_ROUTE,
  inactive: BLOCKED_INACTIVE_ROUTE,
};
